import User from "../views/UserManagement/index.vue";
import UserManagement from "../views/UserManagement/userManage.vue";
import roleManagement from "../views/roleManagement/index.vue";
import claims from "../views/claimsVerification/index.vue";
import insurance from "../views/insuranceCollection/index.vue";
import auditedPage from "../views/claimsVerification/views/auditedPage.vue";
import AuditPage from "../views/claimsVerification/views/AuditPage.vue";
import Collecting from "../views/claimsVerification/views/Collecting.vue";
import VerificationData from "../views/VerificationData/index.vue";
import OrganizationalManagement from "../views/OrganizationalManagement/index.vue";
import Tenant from "../views/Tenant/index.vue";
import collars from "../views/collarsManagement/index.vue";
import CollectiveManagement from "../views/CollectiveManagement/index.vue"
import DataCorrection from "../views/DataCorrection/index.vue"
import CustomerReport from "../views/CustomerReport/index.vue";
import taskMonitor from "../views/taskMonitorManagement/index.vue";
const primariesRoutes = [
  {
    path: "/collars",
    component: collars,
    name: "collarsManagement",
    isMenu: true,
    meta: {
      title: "项圈管理",
      icon: "barcode",
      id: "19",
    },
    redirect: "/collars/collarsInOutPage",
    children: [
      {
        path: "/collars/collarsInOutPage",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/collarsManagement/views/collarsInOutPage.vue"
          ),
        name: "collarsInOutPage",
        isMenu: true,
        meta: {
          title: "项圈出入库",
          icon: "audited",
          id: "20",
        },
      },
      {
        path: "/collars/collarsTakePage",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/collarsManagement/views/collarsTakePage.vue"
          ),
        name: "collarsTakePage",
        isMenu: true,
        meta: {
          title: "项圈领用",
          icon: "audit",
          id: "21",
        },
      },
    ],
  },
  {
    path: "/insurance",
    component: insurance,
    name: "insuranceCollection",
    isMenu: true,
    meta: {
      title: "投保采集",
      icon: "insure",
      id: "7",
    },
    redirect: "/insurance/audited",
    children: [
      {
        path: "/insurance/audited",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/insuranceCollection/views/auditedPage.vue"
          ),
        name: "insuranceAuditedPage",
        isMenu: true,
        meta: {
          title: "已审核",
          icon: "audited",
          id: "13",
        },
      },
      {
        path: "/insurance/AuditPage",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/insuranceCollection/views/AuditPage.vue"
          ),
        name: "insuranceAuditPage",
        isMenu: true,
        meta: {
          title: "待审核",
          icon: "audit",
          id: "12",
        },
      },
      {
        path: "/insurance/Collecting",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/insuranceCollection/views/Collecting.vue"
          ),
        name: "insuranceCollecting",
        isMenu: true,
        meta: {
          title: "采集中",
          icon: "collecting",
          id: "11",
        },
      },
    ],
  },
  {
    path: "/claims",
    component: claims,
    name: "claimsVerification",
    isMenu: true,
    meta: {
      title: "理赔验标",
      icon: "claim",
      id: "8",
    },
    redirect: "/claims/audited",
    children: [
      {
        path: "/claims/audited",
        component: auditedPage,
        name: "auditedPage",
        isMenu: true,
        meta: {
          title: "已审核",
          icon: "audited",
          id: "14",
        },
      },
      {
        path: "/claims/AuditPage",
        component: AuditPage,
        name: "AuditPage",
        isMenu: true,
        meta: {
          title: "待审核",
          icon: "audit",
          id: "15",
        },
      },
      {
        path: "/claims/Collecting",
        component: Collecting,
        name: "Collecting",
        isMenu: true,
        meta: {
          title: "采集中",
          icon: "collecting",
          id: "16",
        },
      },
    ],
  },
  {
    path: "/VerificationData",
    component: VerificationData,
    name: "VerificationData",
    isMenu: true,
    meta: {
      title: "养殖户信息",
      icon: "farm",
      id: "6",
    },
  },

  {
    path: "/",
    component: User,
    name: "UserManagement",
    isMenu: false,
    redirect: "/UserManagement",
  },
  {
    path: "/roleManagement",
    component: roleManagement,
    name: "roleManagement",
    isMenu: true,
    meta: {
      title: "角色管理",
      icon: "role",
      id: "17",
    },
  },
  {
    path: "/UserManagement",
    component: UserManagement,
    name: "UserManagement",
    isMenu: true,
    meta: {
      title: "用户管理",
      icon: "user",
      id: "18",
    },
  },

  {
    path: "/OrganizationalManagement",
    component: OrganizationalManagement,
    name: "OrganizationalManagement",
    isMenu: true,
    meta: {
      title: "机构管理",
      icon: "dept",
      id: "9",
    },
  },
  {
    path: "/Tenant",
    component: Tenant,
    name: "Tenant",
    isMenu: true,
    meta: {
      title: "租户管理",
      icon: "tenan",
      id: "0",
    },
  },
    //数据修正
  {
    path: "/DataCorrection",
    component: DataCorrection,
    name: "DataCorrection",
    isMenu: true,
    meta: {
      title: "数据修正",
      icon: "correction",
      id: "30"
    },
  },
  {
    path: "/CollectiveManagement",
    component: CollectiveManagement,
    name: "CollectiveManagement",
    isMenu: true,
    meta: {
      title: "团体管理",
      icon: "collective",
      id: "22"
    },
  },
  {
    path: "/CustomerReport",
    component: CustomerReport,
    name: "CustomerReport",
    isMenu: true,
    meta: {
      title: "客户上报处理",
      icon: "report",
      id: "23"
    },
  },
  {
    path: "/taskMonitor",
    component: taskMonitor,
    name: "taskMonitorManagement",
    isMenu: true,
    meta: {
      title: "计算任务监控",
      icon: "monitor",
      id: "24",
    },
    redirect: "/taskMonitor/pc_task_analysis",
    children: [
      {
        path: "/taskMonitor/pc_task_analysis",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/taskMonitorManagement/views/TaskAnalysis/index.vue"
          ),
        name: "pc_task_analysis",
        isMenu: true,
        meta: {
          title: "计算任务分析",
          icon: "circleLoop",
          id: "25",
        },
      },
      {
        path: "/taskMonitor/pc_target_computer_quene",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/taskMonitorManagement/views/pc_target_computer_quene.vue"
          ),
        name: "pc_target_computer_quene",
        isMenu: true,
        meta: {
          title: "标的计算队列",
          icon: "circleLoop",
          id: "26",
        },
      },
      {
        path: "/taskMonitor/pc_vector_computer_quene",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/taskMonitorManagement/views/pc_vector_computer_quene.vue"
          ),
        name: "pc_vector_computer_quene",
        isMenu: true,
        meta: {
          title: "向量计算队列",
          icon: "circleLoop",
          id: "27",
        },
      },
      {
        path: "/taskMonitor/pc_target_computer_history",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/taskMonitorManagement/views/pc_target_computer_history.vue"
          ),
        name: "pc_target_computer_history",
        isMenu: true,
        meta: {
          title: "标的计算历史",
          icon: "circleLoop",
          id: "28",
        },
      },
      {
        path: "/taskMonitor/pc_vector_computer_history",
        component: () =>
          import(
            /* webpackChunkName: "loading" */ "../views/taskMonitorManagement/views/pc_vector_computer_history.vue"
          ),
        name: "pc_vector_computer_history",
        isMenu: true,
        meta: {
          title: "向量计算历史",
          icon: "circleLoop",
          id: "29",
        },
      },
    ],
  },
];
export default primariesRoutes;
